/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComplianceFindingSummaryDto } from './ComplianceFindingSummaryDto';
import {
    ComplianceFindingSummaryDtoFromJSON,
    ComplianceFindingSummaryDtoFromJSONTyped,
    ComplianceFindingSummaryDtoToJSON,
    ComplianceFindingSummaryDtoToJSONTyped,
} from './ComplianceFindingSummaryDto';

/**
 * 
 * @export
 * @interface ComplianceAssetFindingDto
 */
export interface ComplianceAssetFindingDto {
    /**
     * 
     * @type {string}
     * @memberof ComplianceAssetFindingDto
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceAssetFindingDto
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceAssetFindingDto
     */
    hostname?: string;
    /**
     * 
     * @type {number}
     * @memberof ComplianceAssetFindingDto
     */
    openFindingCount?: number;
    /**
     * 
     * @type {Array<ComplianceFindingSummaryDto>}
     * @memberof ComplianceAssetFindingDto
     */
    findings?: Array<ComplianceFindingSummaryDto>;
}

/**
 * Check if a given object implements the ComplianceAssetFindingDto interface.
 */
export function instanceOfComplianceAssetFindingDto(value: object): value is ComplianceAssetFindingDto {
    return true;
}

export function ComplianceAssetFindingDtoFromJSON(json: any): ComplianceAssetFindingDto {
    return ComplianceAssetFindingDtoFromJSONTyped(json, false);
}

export function ComplianceAssetFindingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceAssetFindingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'openFindingCount': json['openFindingCount'] == null ? undefined : json['openFindingCount'],
        'findings': json['findings'] == null ? undefined : ((json['findings'] as Array<any>).map(ComplianceFindingSummaryDtoFromJSON)),
    };
}

export function ComplianceAssetFindingDtoToJSON(json: any): ComplianceAssetFindingDto {
    return ComplianceAssetFindingDtoToJSONTyped(json, false);
}

export function ComplianceAssetFindingDtoToJSONTyped(value?: ComplianceAssetFindingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'hostname': value['hostname'],
        'openFindingCount': value['openFindingCount'],
        'findings': value['findings'] == null ? undefined : ((value['findings'] as Array<any>).map(ComplianceFindingSummaryDtoToJSON)),
    };
}

